<template>
  <main id="main" class="d-flex flex-column" style="height: 100vh;">
    <div class="header_page pt-2">
      <p id="title_header_page">گفتگو با {{ teacherName }}</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div ref="messageContainer" class="p-3 flex-grow-1 overflow-auto pb-7 mb-0 pt-5">
      <div v-if="loading && messages.length === 0" class="text-center mt-5">{{ t('loading') }}</div>
      <div v-else-if="messages.length === 0" class="text-center mt-5 text_color_gray">{{ t('no_chat') }}</div>
      <div v-else>
        <div v-for="message in messages" :key="message.id" :class="message.teacher_side ? 'd-flex justify-content-start' : 'd-flex justify-content-end'" class="mb-3">
          <div class="box rounded-4 p-3 shadow-sm" :class="message.teacher_side ? 'bg_white' : 'bg_box_light_theme'" style="max-width: 80%;">
            <p style="white-space: pre-wrap;">{{ message.text }}</p>
            <p class="font_small text_color_gray text-end mt-2">{{ formatTime(message.created_at_local) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input-area position-fixed bottom-0 start-0 w-100 bg_white p-3 shadow-lg">
      <div class="d-flex align-items-center gap-2">
        <input v-model="newMessage" @keyup.enter="sendMessage" type="text" class="w-100 p-3 rounded-pill shadow_input" :placeholder="t('type_message')">
        <button @click="sendMessage" :disabled="sending" class="button rounded-pill p-3" style="min-width: 80px;">
          {{ sending ? '...' : t('send') }}
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'ChatView',
  data() {
    return {
      messages: [],
      newMessage: '',
      teacherId: null,
      teacherName: '',
      userId: null,
      loading: false,
      sending: false,
      pollingInterval: null
    }
  },
  mounted() {
    this.teacherId = this.$route.params.teacherId
    this.teacherName = this.$route.query.teacherName || this.t('teacher')
    this.userId = localStorage.getItem('user_id')
    this.fetchMessages()

    this.pollingInterval = setInterval(() => {
      this.fetchMessages(true)
    }, 5000)
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  },
  methods: {
    async fetchMessages(isBackground = false) {
      if (!this.teacherId) return
      if (!isBackground) {
        this.loading = true
      }
      try {
        const formData = createFormData({
          user_id: this.userId,
          teacher_id: this.teacherId
        })
        const response = await apiClient.post('/show_chats', formData)
        if (response.data.status === 'ok' && response.data.data) {
          const prevLength = this.messages.length
          this.messages = response.data.data
          if (this.messages.length > prevLength) {
             this.scrollToBottom()
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (!isBackground) {
          this.loading = false
          this.scrollToBottom()
        }
      }
    },
    async sendMessage() {
      if (!this.newMessage.trim() || this.sending) return
      this.sending = true
      try {
        const formData = createFormData({
          user_id: this.userId,
          teacher_id: this.teacherId,
          text: this.newMessage
        })
        const response = await apiClient.post('/add_chat', formData)
        if (response.data.status === 'ok') {
          this.newMessage = ''
          this.fetchMessages(true)
        } else {
          this.notify(response.data.message || this.t('error_submit'), 'error')
        }
      } catch (error) {
        console.error(error)
        this.notify(this.t('connection_error'), 'error')
      } finally {
        this.sending = false
      }
    },
    formatTime(dateTime) {
      if (!dateTime) return ''
      const parts = dateTime.split(' ')
      return parts.length > 1 ? parts[1] : dateTime
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    }
  }
}
</script>

<style scoped>
.box {
  min-height: auto;
}
.chat-input-area {
  border-top: 1px solid #eee;
  z-index: 1000;
}
.pb-7 {
    padding-bottom: 7rem !important;
}
</style>